// extracted by mini-css-extract-plugin
module.exports = {"container":"_1M4q0RSplm7vMHPGRAriW8"};